/**
 * AggregatrModule.ts - Configgr module for Aggregatr workspace management
 * 
 * CHANGE HISTORY:
 * - 251031_1153 danielbeer: Initial creation for workspace configuration
 */

/**
 * Aggregatr Configgr Module
 * Provides settings for workspace/view/dataset management
 */
export const aggregatrModule = {
  id: 'aggregatr-workspaces',
  name: 'Workspaces & Datasets',
  icon: '📊',
  category: 'general',
  order: 5,
  description: 'Manage workspaces, views, and datasets for data aggregation',
  
  settings: {
    autoSaveWorkspace: {
      type: 'boolean',
      label: 'Auto-save workspace state',
      description: 'Automatically save workspace/view/dataset selection when changed',
      defaultValue: true,
      scope: ['user']
    },
    
    defaultWorkspace: {
      type: 'string',
      label: 'Default workspace',
      description: 'Workspace to load on application startup',
      defaultValue: 'default',
      scope: ['user']
    },
    
    maxRecents: {
      type: 'number',
      label: 'Recent workspaces to track',
      description: 'Maximum number of recently used workspaces to remember',
      defaultValue: 10,
      scope: ['user'],
      validation: (value: number) => value > 0 && value <= 50
    },
    
    showDatasetSelector: {
      type: 'boolean',
      label: 'Show dataset selector in toolbar',
      description: 'Display the dataset selector component in application toolbar',
      defaultValue: true,
      scope: ['user']
    },
    
    enableWorkspaceSync: {
      type: 'boolean',
      label: 'Sync workspaces across devices',
      description: 'Synchronize workspace configurations via Charactr (when available)',
      defaultValue: false,
      scope: ['user']
    },
    
    confirmWorkspaceDelete: {
      type: 'boolean',
      label: 'Confirm workspace deletion',
      description: 'Show confirmation dialog before deleting a workspace',
      defaultValue: true,
      scope: ['user']
    },
    
    defaultMergeStrategy: {
      type: 'select',
      label: 'Default merge strategy',
      description: 'How to merge data when multiple sources provide the same entity',
      defaultValue: 'merge',
      options: [
        { value: 'first', label: 'First source wins' },
        { value: 'last', label: 'Last source wins' },
        { value: 'merge', label: 'Merge all fields' },
        { value: 'all', label: 'Keep all records' }
      ],
      scope: ['user']
    },
    
    enableDebugLogging: {
      type: 'boolean',
      label: 'Enable debug logging',
      description: 'Log detailed workspace operations to console (for troubleshooting)',
      defaultValue: false,
      scope: ['user']
    }
  }
};

export default aggregatrModule;
